import { render } from "./Privacy.vue?vue&type=template&id=0ff32cca&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=0ff32cca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ff32cca"

export default script